import React, { useState, useEffect } from 'react';
import { Box, IconButton } from '@mui/material';
import { ArrowBackIcon } from 'icons/materialIcons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import AccessoryIntro from './AccessoryIntro';
import AccessorySignIn from './AccessorySignIn';
import AccessoryActivate from './AccessoryActivate';
import AccessorySuccess from './AccessorySuccess';
import { getCardsByUser } from 'apis/userApi';

const AccessoryActivationFlow = ({ initialSerialNumber, accessoryData, isMobile = false }) => {
  const [currentStep, setCurrentStep] = useState(isMobile ? 'signIn' : 'intro');
  const [userCards, setUserCards] = useState([]);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const { authState } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserCards = async () => {
      try {
        if (authState?.user?.userId) {
          const cards = await getCardsByUser(authState.user.userId);
          setUserCards(cards);
        }
      } catch (error) {
      }
    };

    fetchUserCards();
  }, [authState?.user?.userId]);

  const handleBack = () => {
    switch (currentStep) {
      case 'signIn':
        if (isMobile) {
          navigate('/accessory');
        } else {
          setCurrentStep('intro');
        }
        break;
      case 'activate':
        setCurrentStep('signIn');
        break;
      default:
        navigate('/accessory');
    }
  };

  const handleIntroActivate = () => {
    setCurrentStep('signIn');
  };

  const handleSignInSuccess = () => {
    setCurrentStep('activate');
  };

  const handleActivationSuccess = (cardId) => {
    setSelectedCardId(cardId);
    setCurrentStep('success');
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 'intro':
        return (
          <AccessoryIntro
            onActivate={handleIntroActivate}
            onCancel={() => navigate('/accessory')}
            accessoryData={accessoryData}
          />
        );
      case 'signIn':
        return (
          <AccessorySignIn
            onSignInSuccess={handleSignInSuccess}
            accessoryData={accessoryData}
            serialNumber={initialSerialNumber}
          />
        );
      case 'activate':
        return (
          <AccessoryActivate
            onActivationSuccess={handleActivationSuccess}
            userCards={userCards}
            accessoryData={accessoryData}
            serialNumber={initialSerialNumber}
          />
        );
      case 'success':
        return (
          <AccessorySuccess
            cardId={selectedCardId}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Box sx={{ position: 'relative', minHeight: '100vh', backgroundColor: '#fff' }}>
      {currentStep !== 'intro' && currentStep !== 'success' && (
        <IconButton
          onClick={handleBack}
          sx={{
            position: 'absolute',
            top: { xs: '16px', sm: '24px' },
            left: { xs: '16px', sm: '24px' },
            zIndex: 1,
            color: '#000'
          }}
        >
          <ArrowBackIcon />
        </IconButton>
      )}
      {renderCurrentStep()}
    </Box>
  );
};

export default AccessoryActivationFlow;